import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

TextWrapper.propTypes = {
	type: PropTypes.string,
	text: PropTypes.any,
	classList: PropTypes.string,
	color: PropTypes.string,
	icon: PropTypes.element,
	children: PropTypes.element,
};

export default function TextWrapper({
	type = 'subtitle1',
	text = '',
	classList = '',
	color = '',
	icon = null,
	children,
}) {
	if (type === 'caption') {
		classList = classList + ' caption';
	}

	return (
		<>
			{typeof text === 'string' ? (
				<Typography
					component={'div'}
					color={color ? color : ''}
					className={`common-text-wrapper ${classList ? classList : ''}`}
					variant={type}>
					{icon ? icon : null} {text}
				</Typography>
			) : (
				<Box
					typography={type}
					className={`common-text-wrapper ${classList ? classList : ''}`}>
					{text}
				</Box>
			)}
		</>
	);
}
